module.exports = __webpack_public_path__ + "img/photo10.91f5e352.jpg";